import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useAutoTranslation } from 'src/hooks/useTranslate';

export default function DeleteModal({ content }) {
  const t = useAutoTranslation();

  return (
    <Grid container>
      <Grid size={12}>
        <Typography>
          {content ??
            t(
              "This action will permanently delete this family member's details, incase of a proband, all family details will be deleted."
            )}
        </Typography>
      </Grid>
    </Grid>
  );
}
